export default __webpack_public_path__ + "static/media/iGrow.1c73e2e5.png";